import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DarkBg from '@/components/dark-bg.vue';
import CardItem from '@/views/review/components/card-list/card-item.vue';
import EmptyTip from '@/views/review/components/card-list/empty-tip.vue';
import BatchCardDialog from '@/views/review/components/batch-card-dialog.vue';
import TipDialog from '@/views/review/components/tip-dialog.vue';
import CardTopicDialog from '@/views/review/components/card-topic-dialog.vue';
import { TOTAL_NUM_TIP_LIST } from '@/views/review/constant.js';
import { queryTaskInfo as _queryTaskInfo } from '@/api/review.js';
import { getUserInfoDetail as _getUserInfoDetail } from '@/api/login';
export default {
  name: 'CardList',
  components: {
    DarkBg: DarkBg,
    CardItem: CardItem,
    EmptyTip: EmptyTip,
    CardTopicDialog: CardTopicDialog
  },
  props: {
    subjectCode: {
      type: Number,
      default: 0
    },
    taskId: {
      type: Number,
      default: 0
    },
    startReviewUrl: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      taskStatus: 1,
      // 任务状态 1.一般默认状态：（有今日任务）2.只绑定过自学宝，但尚未学习过，推荐复习数据为空状态 3.学习过，但无当日任务状态 4.学习过，当日任务全部完成状态
      cardList: [],
      pageNum: 1,
      pageSize: 30,
      total: 0,
      showDialog: false,
      reviewCardUrl: '',
      isNetWorkError: false,
      userName: '' // offsetHeight: '',
      // isLoading: false

    };
  },
  watch: {
    subjectCode: {
      immediate: true,
      handler: function handler() {
        if (!this.subjectCode) return;
        this.queryTaskInfo(1);
        this.getUserInfoDetail();
      }
    },
    startReviewUrl: {
      immediate: true,
      handler: function handler(val) {
        this.startUrl = val;
      }
    }
  },
  // mounted() {
  //   this.$refs.cardList.wrap.addEventListener('scroll', this.handleScroll, true)
  // },
  //  beforeDestroy() {
  //   this.$refs.cardList.wrap.removeEventListener('scroll', this.handleScroll, true)
  // },
  methods: {
    // handleScroll(){
    //   const scrollTop = this.$refs.cardList.wrap.scrollTop// 滚动高度
    //   const scrollHeight = this.$refs.cardList.wrap.scrollHeight // 内容高度
    //   this.offsetHeight = this.$refs.cardListItem.offsetHeight
    //   if(this.isLoading) return
    //   if (this.offsetHeight + scrollTop > scrollHeight) {
    //     this.isLoading = true
    //     if (this.pageNum >= this.total) return
    //     setTimeout(() => {
    //       this.pageNum += 1
    //       this.queryTaskInfo()
    //     }, 1000)
    //   }
    // },
    // 今日待做任务卡片列表
    queryTaskInfo: function queryTaskInfo(num, type) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_queryTaskInfo, status, data, total, list, taskStatus;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (num) {
                  _this.pageNum = num;
                } // 关闭批量处理弹窗后回到第一页


                _context.next = 3;
                return _queryTaskInfo({
                  subjectId: _this.subjectCode,
                  cardStatus: -1,
                  pageSize: _this.pageSize,
                  pageNumber: _this.pageNum
                });

              case 3:
                _yield$_queryTaskInfo = _context.sent;
                status = _yield$_queryTaskInfo.status;
                data = _yield$_queryTaskInfo.data;

                if (!(status !== 1)) {
                  _context.next = 9;
                  break;
                }

                _this.isNetWorkError = true;
                return _context.abrupt("return");

              case 9:
                _this.isNetWorkError = false;
                total = data.total, list = data.list, taskStatus = data.taskStatus;
                _this.taskStatus = taskStatus;
                _this.total = total || 0;
                _this.cardList = list || []; // this.isLoading = false
                // this.showReviewGuide() // 是否展示复习引导

                if (type === 'update') {
                  // 关闭弹窗后更新数据
                  _this.$emit('updateData');
                }

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNum = val;
      this.queryTaskInfo();
    },
    // 批量处理
    handleBatch: function handleBatch() {
      var _this2 = this;

      this.$showModal(BatchCardDialog, {
        subjectCode: this.subjectCode,
        taskId: this.taskId,
        queryTaskList: function queryTaskList(num, type) {
          return _this2.queryTaskInfo(num, type);
        }
      }, {
        title: '批量处理',
        noFooter: true,
        width: '900px',
        customClass: 'batch-card-dialog'
      });
    },
    // 提示弹窗
    handleTip: function handleTip() {
      this.$showModal(TipDialog, {
        tipList: TOTAL_NUM_TIP_LIST
      }, {
        title: '说明',
        noFooter: true,
        width: '400px',
        showClose: false,
        closeOnClickModal: true,
        customClass: 'tip-dialog'
      });
    },
    // 点击卡片
    handleCardClick: function handleCardClick(item) {
      this.reviewCardUrl = item.reviewCardUrl;
      this.showDialog = true;
    },
    // 获取用户名
    getUserInfoDetail: function getUserInfoDetail() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var userInfo, params, _yield$_getUserInfoDe, status, data, name, avaterUrl;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                userInfo = JSON.parse(localStorage.getItem('userInfo'));
                params = {
                  uid: userInfo.uid
                };
                _context2.next = 4;
                return _getUserInfoDetail(params);

              case 4:
                _yield$_getUserInfoDe = _context2.sent;
                status = _yield$_getUserInfoDe.status;
                data = _yield$_getUserInfoDe.data;

                if (!(status !== 1)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return");

              case 9:
                name = data.name, avaterUrl = data.avaterUrl;

                _this3.$store.dispatch('setUsername', name);

                _this3.$store.dispatch('setUserAvatar', avaterUrl);

                _this3.userName = name;

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};